import type { LucideIcon } from 'lucide-react'
import type { ComponentProps } from 'react'
import { Button } from '@/components/ui/button'
import { Tooltip } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

type Props = { label: string; icon: LucideIcon; danger?: boolean } & Omit<ComponentProps<typeof Button>, 'children' | 'size' | 'variant'>

export function IconAction({ label, icon: Icon, danger, className, ...props }: Props) {
  return (
    <Tooltip content={label} side="top">
      <Button size="icon" variant="outline" className={cn('size-8', danger && 'text-destructive hover:text-destructive', className)} aria-label={label} {...props}>
        <Icon />
      </Button>
    </Tooltip>
  )
}
